import { render, staticRenderFns } from "./add-label.vue?vue&type=template&id=68d978f6&scoped=true&"
import script from "./add-label.vue?vue&type=script&lang=js&"
export * from "./add-label.vue?vue&type=script&lang=js&"
import style0 from "./add-label.vue?vue&type=style&index=0&id=68d978f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d978f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d978f6')) {
      api.createRecord('68d978f6', component.options)
    } else {
      api.reload('68d978f6', component.options)
    }
    module.hot.accept("./add-label.vue?vue&type=template&id=68d978f6&scoped=true&", function () {
      api.rerender('68d978f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/add-label.vue"
export default component.exports